<script setup>
import { Wrench, Calendar, FileText, Users } from 'lucide-vue-next'

const props = defineProps({
  summary: { type: Object, required: true },
})

const cards = [
  { key: 'status',            label: 'Status',              icon: Wrench,   accent: 'bg-up-orange/10 text-up-orange' },
  { key: 'delivery_forecast', label: 'Previsão de entrega', icon: Calendar, accent: 'bg-up-navy/5 text-up-navy' },
  { key: 'service_order',     label: 'Ordem de serviço',    icon: FileText, accent: 'bg-up-navy/5 text-up-navy' },
  { key: 'technician',        label: 'Responsável técnico', icon: Users,    accent: 'bg-up-navy/5 text-up-navy' },
]
</script>

<template>
  <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
    <div
      v-for="card in cards"
      :key="card.key"
      class="flex items-center gap-4 rounded-card bg-white px-5 py-4 shadow-card"
    >
      <span class="flex h-11 w-11 shrink-0 items-center justify-center rounded-full" :class="card.accent" aria-hidden="true">
        <component :is="card.icon" class="h-5 w-5" />
      </span>
      <div class="min-w-0">
        <p class="text-sm text-slate-500">{{ card.label }}</p>
        <p class="truncate text-lg font-bold text-up-navy">{{ props.summary[card.key] }}</p>
      </div>
    </div>
  </div>
</template>
